import { is, List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as CountryActions from "../../actions/CountryActions";
import * as Comp from "..";
import { Country } from "../../models/country/Country";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    countries: state.countries.countries,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadData: () => dispatch(CountryActions.init()),
});

interface OwnProps {
    onUpdated?: (countries: List<Country>) => void;
}

type ConnectedState = Comp.Base.DefaultConnectedState & {
    countries: List<Country>;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadData: () => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class LoaderComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {
        if (this.props.countries.size)
            this.handleOnUpdated();
        else
            this.props.loadData();
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        if (!is(prevProps.countries, this.props.countries))
            this.handleOnUpdated();
    }

    public render() {
        return null;
    }

    private handleOnUpdated() {
        if (typeof this.props.onUpdated === "function")
            this.props.onUpdated(this.props.countries);
    }
}

export const CountriesLoader: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(LoaderComponent);



// WEBPACK FOOTER //
// ./src/components/reusable/CountriesLoader.tsx